import React from 'react';
import { DashboardPage } from '../../toolympus/components/Dashboard/DashboardPage';

export const DashboardContainer = () => {
   return <DashboardPage defaultDashboard="main" allowChangeDashboard getEditLink={() => "/dashboards"} />
}